import BaseModel from '../core/BaseModel'
import PropertyTypeModel from '@/models/PropertyTypeModel'

export default class PropertyForSaleModel extends BaseModel {

    constructor() {
        super({
                name: "property_for_sale",
                tableName: 'property_for_sale_post',
                label: "Property for sale",
                display_key: 'property_name',
                default_order: { key: 'updated_at', direction: 'desc' }
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    width: 5,
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                property_id: {
                    name: 'property_id',
                    type: "String",
                    label: 'Property ID',
                    filter: { type: 'input', match: 'contains' },
                    width: 10,
                },
                property_name: {
                    name: 'property_name',
                    type: "String",
                    label: 'Property name',
                    filter: { type: 'input', match: 'contains' },
                    width: 12,
                },
                
                address: {
                    name: 'address',
                    type: "String",
                    label: 'Address',
                    filter: { type: 'input', match: 'contains' },
                    width: 14,
                },
                property_type_name: {
                    name: 'property_type_name',
                    type: "String",
                    label: 'Type of property',
                    models: new PropertyTypeModel(),
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
                    width: 12,
                },
                price: {
                    name: 'price',
                    type: "number",
                    inputOptions: { mode: "currency" },
                    label: 'Price (€)',
                 //   filter: { type: 'input', match: 'contains' },
                    width: 10,
                },
                bedroom: {
                    name: 'bedroom',
                    type: "String",
                    label: 'Bedrooms',
                   // filter: { type: 'input', match: 'contains' },
                    class: "center",
                    width: 8,
                },
                bathroom: {
                    name: 'bathroom',
                    type: "String",
                    label: 'Bathrooms',
                   // filter: { type: 'input', match: 'contains' },
                    class: "center",
                    width: 8,
                },
                acreage: {
                    name: 'acreage',
                    type: "String",
                    label: 'Acreage (m2)',
                  //  filter: { type: 'input', match: 'contains' },
                    class: "center",
                    width: 9,
                },
                extra_information: {
                    name: 'extra_information',
                    type: "Text",
                    label: 'Extra infor',
                    filter: { type: 'input', match: 'contains' },
                    width: 10,
                },
                contact_count: {
                    name: 'contact_count',
                    type: "CustomUrl",
                    label: 'Number of contacts',
                 //   filter: { type: 'input', match: 'contains' },
                    class: "center",
                    width: 10,
                },
                display_order: {
                    name: 'display_order',
                    type: "String",
                    label: 'Display order',
                  //  filter: { type: 'input', match: 'contains' },
                    class: "center",
                    width: 9,
                },
                active_html: {
                    name: 'active_html',
                    type: "Text",
                    label: 'Active',
                    width: 7,
                    class: "center",
                },
                updated_name: {
                    name: 'updated_name',
                    type: "String",
                    label: 'Updated by',
                    filter: { type: 'input', match: 'contains' },
                    width: 10,
                },
                updated_at: {
                    name: 'updated_at',
                    type: "Datetime",
                    label: 'Updated date',
                    filter: { type: 'DateRange', match: 'contains' },
                    width: 10,
                },
            })
    }
}
